import * as React from 'react';
import px from 'prop-types';
import { useItemAttributesTabs } from 'Common/hooks';
import { Formatter } from 'Common/utils';
import { Translation } from 'Common/components/localization';
import ProductGallery from './ProductGallery';

export default function ItemDetailsCard({ attributesToDisplay, itemData }) {
    const itemContent = useItemAttributesTabs(itemData?.Attributes, attributesToDisplay);

    const [mainImage, setMainImage] = React.useState(itemData.GalleryMedia[0]);

    const selectedImage = React.useCallback((image) => {
        setMainImage(image);
    }, []);

    return itemData ? (
        <div className="ItemDetailsCard container-fluid">
            <div className="ItemGallery">
                <ProductGallery
                    mainMedia={mainImage}
                    media={itemData.GalleryMedia}
                    noGallery={false}
                    noGalleryMobile={true}
                    useImageModal={false}
                    useCarousel={true}
                    onSelectImage={selectedImage}
                />
            </div>
            <div className="ItemDetailsCard__title">
                {itemData.DisplayName}
            </div>
            <div className="ItemDetailsCard__details-container">
                <div className="ItemDetailsCard__detail-row">
                    <div className="ItemDetailsCard__detail-header">
                        <Translation id="Commerce.Product.ChildrenTable.Code" />
                        {':'}
                    </div>
                    <div>{itemData.Code}</div>
                </div>
                <div className="ItemDetailsCard__detail-row">
                    <div className="ItemDetailsCard__detail-header">
                        <Translation id="Commerce.Product.ChildrenTable.Price" />
                        {':'}
                    </div>
                    <div>
                        {itemData?.Price ? (
                            <>
                                {Formatter.currency(
                                    itemData?.Price?.ListPrice.Amount,
                                    itemData?.Price?.ListPrice.Currency
                                )}
                            </>
                        ) : null}
                    </div>
                </div>
            </div>
            {itemContent?.map((a) => {
                return (
                    a.attributes.length ? (
                    <div key={a.title} className="attribute">
                        <div className="attribute__header">
                            <Translation id={a.title} />
                        </div>
                        {a.attributes.map((attr) => {
                            return (
                                 
                                attr.value.length > 1 ? (attr.value.map((v, index) => (
                                    <div key={index} className='attribute__value'>{v}</div>
                                )
                                )) : (
                                <div key={attr.attributeName} className='attribute__value'>{attr.attributeKey ? (`${attr.attributeKey}: ${attr.value}`) : `${attr.value}`}</div>
                            ))
                        })}
                    </div>
                ) : null);
            })}
        </div>
    ) : null;
}

ItemDetailsCard.propTypes = {
    attributesToDisplay: px.arrayOf(px.object),
    itemData: px.object,
};
